import React from 'react'
import { toast, Slide } from 'react-toastify';
import HrbTranslate from '../components/language/HrbTranslate';

export const useToast = () => {

    // the styling for this currently lives in /stylesheets/index.scss
    // under the .Toastify__toast class
    const options = {
        className: 'black-background-toast',
        position: "bottom-left",
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    }

    const success = (labelKey) => {
        toast.success(<HrbTranslate text={labelKey} />, options);
    }

    const error = (labelKey) => {
        toast.error(<HrbTranslate text={labelKey} />, options);
    }

    return { success, error };
}